// Seed data voor onboarding formulieren

export const expertiseOptions = [
  'Sales',
  'Marketing', 
  'Video & Content',
  'Tech & Development',
  'Finance & Investment',
  'Health & Wellness',
  'Leadership & Management',
  'Design & Creatie',
  'Coaching & Training',
  'E-commerce',
  'Real Estate',
  'Consulting',
  'HR & Recruitment',
  'Legal & Compliance',
  'Operations',
  'Strategy',
  'Product Management',
  'Data & Analytics',
  'Cybersecurity',
  'Blockchain & Crypto'
];

export const interestsOptions = [
  'Podcast hosting',
  'Content creatie',
  'Partnerships',
  'Investering & funding',
  'Product development',
  'AI & Machine Learning',
  'Sustainable business',
  'International expansion',
  'Team building',
  'Personal branding',
  'Digital marketing',
  'Customer experience',
  'Innovation',
  'Networking events',
  'Mentorship',
  'Public speaking',
  'Industry trends',
  'Startup ecosystem',
  'Work-life balance',
  'Remote work'
];

export const industriesOptions = [
  'Technology',
  'Healthcare',
  'Finance',
  'E-commerce',
  'Real Estate',
  'Education',
  'Manufacturing',
  'Consulting',
  'Media & Entertainment',
  'Food & Beverage',
  'Fashion & Retail',
  'Automotive',
  'Energy',
  'Telecommunications',
  'Construction',
  'Agriculture',
  'Travel & Hospitality',
  'Sports & Fitness',
  'Government',
  'Non-profit'
];

export const regionsOptions = [
  // Nederlandse provincies (voor betere matching)
  'Noord-Holland',
  'Zuid-Holland',
  'Utrecht',
  'Noord-Brabant',
  'Gelderland',
  'Overijssel',
  'Limburg',
  'Friesland',
  'Groningen',
  'Drenthe',
  'Flevoland',
  'Zeeland',
  // Algemene regio's
  'Nederland - Noord',
  'Nederland - Randstad', 
  'Nederland - Oost',
  'Nederland - Zuid',
  // Internationale regio's
  'België',
  'Duitsland',
  'Frankrijk',
  'Verenigd Koninkrijk',
  'Verenigde Staten',
  'Internationaal'
];

// ✅ FIX: Nederlandse provincies voor betere matching
export const dutchProvinces = [
  'Noord-Holland',
  'Zuid-Holland',
  'Utrecht',
  'Noord-Brabant',
  'Gelderland',
  'Overijssel',
  'Limburg',
  'Friesland',
  'Groningen',
  'Drenthe',
  'Flevoland',
  'Zeeland'
];

// ✅ FIX: Nederlandse steden voor dropdown selectie (alfabetisch gesorteerd)
export const dutchCities = [
  'Alkmaar', 'Almelo', 'Almere', 'Alphen aan den Rijn', 'Amersfoort',
  'Amsterdam', 'Apeldoorn', 'Arnhem', 'Breda', 'Capelle aan den IJssel',
  'Delft', 'Den Haag', 'Deventer', 'Dordrecht', 'Ede', 'Eindhoven',
  'Emmen', 'Enschede', 'Gouda', 'Groningen', 'Haarlem', 'Haarlemmermeer',
  'Heerlen', 'Heerenveen', 'Helmond', 'Hengelo', 'Hilversum', 'Hoofddorp',
  'Leeuwarden', 'Leiden', 'Lelystad', 'Maastricht', 'Nijmegen', 'Purmerend',
  'Roosendaal', 'Rotterdam', 'Schiedam', 's-Hertogenbosch', 'Tilburg',
  'Utrecht', 'Venlo', 'Vlaardingen', 'Zaanstad', 'Zoetermeer', 'Zwolle'
].sort(); // Alfabetisch gesorteerd

// ✅ FIX: Postcode ranges voor Nederlandse postcodes (eerste 2 cijfers = gebied)
export const dutchPostcodeAreas = [
  { code: '1000-1299', area: 'Amsterdam Centrum' },
  { code: '1300-1399', area: 'Amsterdam Zuid' },
  { code: '1400-1499', area: 'Amsterdam Noord' },
  { code: '1500-1599', area: 'Amsterdam Oost' },
  { code: '2000-2099', area: 'Rotterdam Centrum' },
  { code: '2100-2199', area: 'Rotterdam Zuid' },
  { code: '2200-2299', area: 'Rotterdam Noord' },
  { code: '2500-2599', area: 'Den Haag' },
  { code: '3000-3099', area: 'Utrecht' },
  { code: '3500-3599', area: 'Utrecht Overig' },
  { code: '4000-4099', area: 'Eindhoven' },
  { code: '5000-5099', area: 'Tilburg' },
  { code: '6000-6099', area: 'Maastricht' },
  { code: '7000-7099', area: 'Enschede' },
  { code: '8000-8099', area: 'Zwolle' },
  { code: '9000-9099', area: 'Groningen' },
  { code: '1000-9999', area: 'Andere Nederlandse postcode' }
];

export const rolesOptions = [
  'CEO/Founder',
  'CTO/Tech Lead',
  'CMO/Marketing Lead',
  'Sales Manager',
  'Product Manager',
  'Operations Manager',
  'HR Manager',
  'Finance Manager',
  'Consultant',
  'Freelancer',
  'Investor',
  'Board Member',
  'Team Lead',
  'Senior Developer',
  'Designer',
  'Andere'
];

export const learningGoalsOptions = [
  'Podcast skills',
  'Presentatie technieken',
  'Sales vaardigheden',
  'Leiderschap ontwikkeling',
  'Personal brand opbouwen',
  'Netwerk uitbreiden',
  'Investering strategieën',
  'Digital marketing',
  'Product development',
  'Team management',
  'Public speaking',
  'Business strategy',
  'Customer acquisition',
  'International expansion',
  'Innovation management'
];

export const challengesOptions = [
  'Sales & customer acquisition',
  'Zichtbaarheid & marketing',
  'Partnerships vinden',
  'Team hiring',
  'Prijsstrategie',
  'Product-market fit',
  'Funding & investment',
  'International expansion',
  'Technology challenges',
  'Competition',
  'Regulation & compliance',
  'Supply chain',
  'Customer retention',
  'Scaling operations',
  'Brand building'
];

export const offersValueOptions = [
  'Design & branding',
  'Coaching & mentoring',
  'Sales expertise',
  'Video & content productie',
  'Tech development',
  'Marketing strategieën',
  'Financial planning',
  'Legal advies',
  'HR & recruitment',
  'Operations optimalisatie',
  'International connections',
  'Investment opportunities',
  'Partnership introductions',
  'Speaking engagements',
  'Training & workshops'
];

export const eventThemesOptions = [
  'Business development',
  'Technology & innovation',
  'Marketing & sales',
  'Finance & investment',
  'Health & wellness',
  'Leadership & management',
  'Entrepreneurship',
  'Sustainability',
  'Digital transformation',
  'AI & future tech',
  'Personal development',
  'Industry networking',
  'Startup ecosystem',
  'International business',
  'Creative industries'
];

export const contentTopicsOptions = [
  'Entrepreneurship',
  'Technology trends',
  'Sales & marketing',
  'Investment & finance',
  'Leadership insights',
  'Industry analysis',
  'Success stories',
  'Innovation showcase',
  'Market opportunities',
  'Business strategy',
  'Personal development',
  'Network building',
  'Future predictions',
  'Case studies',
  'Expert interviews'
];

export const rewardsOptions = [
  'Spotlight in community',
  'Podcast appearance',
  'Training toegang',
  'Event kortingen',
  'Premium features',
  'Expert badge',
  'Networking privileges',
  'Content collaboration',
  'Speaking opportunities',
  'Partnership introductions'
];

export const languagesOptions = [
  'Nederlands',
  'Engels',
  'Duits',
  'Frans',
  'Spaans',
  'Italiaans',
  'Portugees',
  'Pools',
  'Russisch',
  'Chinees',
  'Japans',
  'Arabisch'
];

export const timezonesOptions = [
  { value: 'Europe/Amsterdam', label: 'Nederland (CET/CEST)' },
  { value: 'Europe/Brussels', label: 'België (CET/CEST)' },
  { value: 'Europe/Berlin', label: 'Duitsland (CET/CEST)' },
  { value: 'Europe/London', label: 'Verenigd Koninkrijk (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Frankrijk (CET/CEST)' },
  { value: 'America/New_York', label: 'VS Oost (EST/EDT)' },
  { value: 'America/Los_Angeles', label: 'VS West (PST/PDT)' },
  { value: 'Asia/Dubai', label: 'Dubai (GST)' },
  { value: 'Asia/Singapore', label: 'Singapore (SGT)' },
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' }
];

export const daysOfWeekOptions = [
  { value: 'ma', label: 'Maandag' },
  { value: 'di', label: 'Dinsdag' },
  { value: 'wo', label: 'Woensdag' },
  { value: 'do', label: 'Donderdag' },
  { value: 'vr', label: 'Vrijdag' },
  { value: 'za', label: 'Zaterdag' },
  { value: 'zo', label: 'Zondag' }
];






















